export const LOCAL_STORAGE_KEYS = {
	COUNTRY_CODE: 'country_code',
	SUBDIVISION: 'subdivision',
	USER_DATA: 'user_data',
	MENU_DATA: 'menu_data',
	LANDING_SCROLLED_POINTS: 'landing_scrolled_points_main',
	PRICING_SCROLLED_POINTS: 'pricing_scrolled_points',
	REMOVE_BG_SCROLLED_POINTS: 'removeBg_scrolled_points',
	IMAGE_GEN_SCROLLED_POINTS: 'imageGen_scrolled_points',
	IMAGE_ENHANCE_SCROLLED_POINTS: 'imageEnhance_scrolled_points',
	IMAGE_ENHANCER_SCROLLED_POINTS: 'imageEnhance_scrolled_points',
	OBJECT_REMOVER_SCROLLED_POINTS: 'objectRemover_scrolled_points',
	BACKGROUND_REMOVER_SCROLLED_POINTS: 'backgroundRemover_scrolled_points',
	ADD_TEXT_TO_PHOTO_SCROLLED_POINTS: 'addText_scrolled_points',
	BLUR_BG_SCROLLED_POINTS: 'blurBG_scrolled_points',
	CHANGE_BG_COLOR_SCROLLED_POINTS: 'changeBG_scrolled_points',
	AI_GENERATED_BACKGROUND_SCROLLED_POINTS: 'aiBackground_scrolled_points',
	CREATE_CONTENT_SCROLLED_POINTS: 'createContent_scrolled_points',
	LISTING_SCROLLED_POINTS: 'listing_scrolled_points',
	MAGIC_ERASER_SCROLLED_POINTS: 'magicEraser_scrolled_points',
	MARKETPLACES_SCROLLED_POINTS: 'marketplaces_scrolled_points',
	PRODUCT_CARDS_SCROLLED_POINTS: 'productCards_scrolled_points',
	PROMOTE_EVENTS_SCROLLED_POINTS: 'promoteEvents_scrolled_points',
	REVIEWS_SCROLLED_POINTS: 'reviews_scrolled_points',
	GENERATE_IMAGES_WITH_AI_SCROLLED_POINTS: 'generateWithAI_scrolled_points',
	FOR_BUSINESS_SCROLLED_POINTS: 'business_scrolled_points',
	APPAREL_PHOTOGRAPHY_SCROLLED_POINTS: 'apparelPhotography_scrolled_points',
	FURNITURE_IMAGES_SCROLLED_POINTS: 'furnitureImages_scrolled_points',
	BEAUTY_PRODUCTS_SCROLLED_POINTS: 'beautyProduct_scrolled_points',
	JEWELRY_IMAGES_SCROLLED_POINTS: 'jewelryImages_scrolled_points',
	ONLINE_CREATIVE_SCROLLED_POINTS: 'onlineCreative_scrolled_points',
	BRANDED_GRAPHIC_SCROLLED_POINTS: 'brandedGraphic_scrolled_points',
	EMAIL_MARKETING_SCROLLED_POINTS: 'emailMarketing_scrolled_points',
	REAL_ESTATE_SCROLLED_POINTS: 'realEstate_scrolled_points',
	IMAGE_UPSCALE_SCROLLED_POINTS: 'imageUpscale_scrolled_points',
	IMAGE_UPSCALER_SCROLLED_POINTS: 'imageUpscaler_scrolled_points',
	AI_FILTERS_LEGO_SCROLLED_POINTS: 'aiFilterLego_scrolled_points',
	AI_FILTERS_GHIBLI_SCROLLED_POINTS: 'aiFilterGhibli_scrolled_points',
	AI_FILTERS_STARTER_PACK_SCROLLED_POINTS:
		'aiFilterStarterPack_scrolled_points',
	ALL_TOOLS_SCROLLED_POINTS: 'allTools_scrolled_points',
	HEADSHOT_GENERATOR_SCROLLED_POINTS: 'headshotGenerator_scrolled_points',
	HEADSHOT_GENERATOR_V2_SCROLLED_POINTS: 'headshotGeneratorV2_scrolled_points',
	WATERMARK_REMOVER_SCROLLED_POINTS: 'watermarkRemover_scrolled_points',
	VIDEO_WATERMARK_REMOVER_SCROLLED_POINTS:
		'videoWatermarkRemover_scrolled_points',
	IMAGE_WATERMARK_REMOVER_SCROLLED_POINTS:
		'imageWatermarkRemover_scrolled_points',
	TEXT_TO_VIDEO_SCROLLED_POINTS: 'textToVideo_scrolled_points',
	IMAGE_TO_VIDEO_SCROLLED_POINTS: 'imageToVideo_scrolled_points',
	AI_VIDEO_GENERATOR_SCROLLED_POINTS: 'aiVideoGenerator_scrolled_points',
	AI_IMAGE_COMBINER_SCROLLED_POINTS: 'aiImageCombiner_scrolled_points',
	PHOTO_TRANSLATOR_SCROLLED_POINTS: 'photoTranslator_scrolled_points',
	ENGLISH_IMAGE_TRANSLATOR_SCROLLED_POINTS:
		'englishImageTranslator_scrolled_points',
	TRANSLATE_IMAGE_TO_ENGLISH_SCROLLED_POINTS:
		'translateImageToEnglish_scrolled_points',
	IMAGE_RESIZER_SCROLLED_POINTS: 'imageResizer_scrolled_points',
	CROP_IMAGE_SCROLLED_POINTS: 'cropImage_scrolled_points',
	COLOR_PALETTE_FROM_IMAGE_SCROLLED_POINTS:
		'colorPaletteFromImage_scrolled_points',
	HEX_COLOR_PICKER_FROM_IMAGE_SCROLLED_POINTS:
		'hexColorPickerFromImage_scrolled_points',
	COLOR_PICKER_FROM_IMAGE_SCROLLED_POINTS:
		'colorPickerFromImage_scrolled_points',
	RGB_COLOR_PICKER_FROM_IMAGE_SCROLLED_POINTS:
		'rgbColorPickerFromImage_scrolled_points',
	FLIP_IMAGE_SCROLLED_POINTS: 'flipImage_scrolled_points',
	ROTATE_IMAGE_SCROLLED_POINTS: 'rotateImage_scrolled_points',
	BACKGROUND_EDITOR_SCROLLED_POINTS: 'backgroundEditor_scrolled_points',
	BACKGROUND_CHANGER_SCROLLED_POINTS: 'backgroundChanger_scrolled_points',
	BLUR_BACKGROUND_SCROLLED_POINTS: 'blurBackground_scrolled_points',
	PASSPORT_PHOTO_MAKER_SCROLLED_POINTS: 'passportPhotoMaker_scrolled_points',
	SOUTH_PARK_CHARACTER_GENERATOR_SCROLLED_POINTS:
		'southParkCharacterGenerator_scrolled_points',
	AI_ART_GENERATOR_SCROLLED_POINTS: 'aiArtGenerator_scrolled_points',
	AI_CLAY_FILTER_SCROLLED_POINTS: 'aiClayFilter_scrolled_points',
	AI_BRATZ_GENERATOR_SCROLLED_POINTS: 'aiBratzGenerator_scrolled_points',
	AI_POKEMON_GENERATOR_SCROLLED_POINTS: 'aiPokemonGenerator_scrolled_points',
	AI_FILTERS_SCROLLED_POINTS: 'aiFilters_scrolled_points',
	ANIME_GENERATOR_SCROLLED_POINTS: 'animeGenerator_scrolled_points',
	CARTOON_GENERATOR_SCROLLED_POINTS: 'cartoonGenerator_scrolled_points',
	PIXAR_AI_GENERATOR_SCROLLED_POINTS: 'pixarAiGenerator_scrolled_points',
	AI_CHIBI_MAKER_SCROLLED_POINTS: 'aiChibiMaker_scrolled_points',
	AI_IMAGE_EXTENDER_SCROLLED_POINTS: 'imageExtender_scrolled_points',
	AI_IMAGE_EXTENDER_V2_SCROLLED_POINTS: 'imageExtenderV2_scrolled_points',
	AI_IMAGE_EDITOR_SCROLLED_POINTS: 'aiImageEditor_scrolled_points',
	AI_HAIRSTYLE_SCROLLED_POINTS: 'aiHairStyle_scrolled_points',
	AI_HAIRSTYLE_V2_SCROLLED_POINTS: 'aiHairStyleV2_scrolled_points',
	IMAGE_UNBLUR_SCROLLED_POINTS: 'imageUnblur_scrolled_points',
	CLOTHES_CHANGER_SCROLLED_POINTS: 'clothesChanger_scrolled_points',
	AI_FACE_SWAP_SCROLLED_POINTS: 'aiFaceSwap_scrolled_points',
	AI_IMAGE_QUALITY_IMPROVER_SCROLLED_POINTS:
		'imageQualityImprover_scrolled_points',
	HD_PHOTO_CONVERTER_SCROLLED_POINTS: 'hdPhotoConverter_scrolled_points',
	AI_IMAGE_DEPIXELIZER_SCROLLED_POINTS: 'imageDepixelizer_scrolled_points',
	AI_RELIGHT_SCROLLED_POINTS: 'aiRelight_scrolled_points',
	AI_RETAKE_SCROLLED_POINTS: 'aiRetake_scrolled_points',
	AI_IMAGE_DENOISER_SCROLLED_POINTS: 'imageDenoiser_scrolled_points',
	RESOLUTION_INCREASER_SCROLLED_POINTS: 'resolutionIncreaser_scrolled_points',
	AI_IMAGE_ENLARGER_SCROLLED_POINTS: 'imageEnlarger_scrolled_points',
	AI_PHOTO_RESTORATION_SCROLLED_POINTS: 'photoRestoration_scrolled_points',
	IMAGE_SHARPENER_SCROLLED_POINTS: 'imageSharpener_scrolled_points',
	AI_IMAGE_DETECTOR_SCROLLED_POINTS: 'aiImageDetector_scrolled_points',
	AI_IMAGE_GENERATOR_SCROLLED_POINTS: 'aiImageGenerator_scrolled_points',
	TEXT_TO_IMAGE_AI_SCROLLED_POINTS: 'textToImageAi_scrolled_points',
	TEXT_TO_ART_AI_SCROLLED_POINTS: 'textToArtAi_scrolled_points',
	IMAGE_COLORIZER_SCROLLED_POINTS: 'imageColorizer_scrolled_points',
	IMAGE_COLORIZER_V2_SCROLLED_POINTS: 'imageColorizerV2_scrolled_points',
	AI_NEON_FILTER_SCROLLED_POINTS: 'aiNeonFilter_scrolled_points',
	AI_DISNEY_FILTER_SCROLLED_POINTS: 'aiDisneyFilter_scrolled_points',
	PHOTO_RECOLOR_SCROLLED_POINTS: 'photoRecolor_scrolled_points',
	PHOTO_TO_ILLUSTRATION_SCROLLED_POINTS: 'photoToIllustration_scrolled_points',
	IMAGE_TO_DRAWING_SCROLLED_POINTS: 'imageToDrawing_scrolled_points',
	AI_COMIC_FILTER_SCROLLED_POINTS: 'aiComicFilter_scrolled_points',
	PHOTO_TO_PAINTING_SCROLLED_POINTS: 'photoToPainting_scrolled_points',
	PHOTO_TO_SKETCH_SCROLLED_POINTS: 'photoToSketch_scrolled_points',
	AI_BARBIE_DOLL_SCROLLED_POINTS: 'aiBarbieDoll_scrolled_points',
	AI_DOLL_GENERATOR_SCROLLED_POINTS: 'aiDollGenerator_scrolled_points',
	AI_MANGA_GENERATOR_SCROLLED_POINTS: 'aiMangaGenerator_scrolled_points',
	AI_ACTION_FIGURE_GENERATOR_SCROLLED_POINTS:
		'aiActionFigureGenerator_scrolled_points',
	AI_TOY_GENERATOR_SCROLLED_POINTS: 'aiToyGenerator_scrolled_points',
	USER_ID: 'onboarding_user_id',
	USER_EMAIL: 'onboarding_user_email',
	GENERATIVE_FILL_SCROLLED_POINTS: 'generativeFill_scrolled_points',
	AI_BACKGROUND_SCROLLED_POINTS: 'aiBackground_scrolled_points',
	AI_PFP_MAKER_SCROLLED_POINTS: 'aiPfpMaker_scrolled_points',
	AI_PROFILE_PICTURE_MAKER_SCROLLED_POINTS:
		'aiProfilePictureMaker_scrolled_points',
	AI_AVATAR_GENERATOR_SCROLLED_POINTS: 'aiAvatarGenerator_scrolled_points',
	AI_PORTRAIT_GENERATOR_SCROLLED_POINTS: 'aiPortraitGenerator_scrolled_points',
	PROFESSIONAL_AI_HEADSHOTS_SCROLLED_POINTS:
		'professionalAiHeadshots_scrolled_points',
	AI_CV_PHOTO_GENERATOR_SCROLLED_POINTS: 'aiCvPhotoGenerator_scrolled_points',
	AI_BUSINESS_PHOTO_GENERATOR_SCROLLED_POINTS:
		'aiBusinessPhotoGenerator_scrolled_points',
	AI_DATING_PHOTO_GENERATOR_SCROLLED_POINTS:
		'aiDatingPhotoGenerator_scrolled_points',
	AI_TATTOO_GENERATOR_SCROLLED_POINTS: 'aiTattooGenerator_scrolled_points',
	TATTOO_FONT_GENERATOR_SCROLLED_POINTS: 'tattooFontGenerator_scrolled_points',
	FONT_GENERATOR_SCROLLED_POINTS: 'fontGenerator_scrolled_points',
	TATTOO_TEXT_GENERATOR_SCROLLED_POINTS: 'tattooTextGenerator_scrolled_points',
	TATTOO_FROM_PHOTO_CONVERTER_SCROLLED_POINTS:
		'tattooFromPhotoConverter_scrolled_points',
	CUTOUT_IMAGE_SCROLLED_POINTS: 'cutoutImage_scrolled_points',
	PNG_MAKER_SCROLLED_POINTS: 'pngMaker_scrolled_points',
	TRANSPARENT_BACKGROUND_SCROLLED_POINTS:
		'transparentBackground_scrolled_points',
	SIGNATURE_BACKGROUND_REMOVER_SCROLLED_POINTS:
		'signatureBackgroundRemover_scrolled_points',
	DELETE_BACKGROUND_SCROLLED_POINTS: 'deleteBackground_scrolled_points',
	CLEAR_BACKGROUND_SCROLLED_POINTS: 'clearBackground_scrolled_points',
	WHITE_BACKGROUND_SCROLLED_POINTS: 'whiteBackground_scrolled_points',
	BLACK_BACKGROUND_SCROLLED_POINTS: 'blackBackground_scrolled_points',
	BACKGROUND_COLOR_CHANGER_SCROLLED_POINTS:
		'backgroundColorChanger_scrolled_points',
	AI_LOGO_GENERATOR_SCROLLED_POINTS: 'aiLogoGenerator_scrolled_points',
	WEBP_TO_PNG_SCROLLED_POINTS: 'webpToPng_scrolled_points',
	WEBP_TO_JPG_SCROLLED_POINTS: 'webpToJpg_scrolled_points',
	HEIC_TO_JPEG_SCROLLED_POINTS: 'heicToJpeg_scrolled_points',
	HEIC_TO_JPG_SCROLLED_POINTS: 'heicToJpg_scrolled_points',
	HEIC_TO_PNG_SCROLLED_POINTS: 'heicToPng_scrolled_points',
	PNG_CONVERTER_SCROLLED_POINTS: 'pngConverter_scrolled_points',
	WEBP_CONVERTER_SCROLLED_POINTS: 'webpConverter_scrolled_points',
	TIFF_TO_JPG_SCROLLED_POINTS: 'tiffToJpg_scrolled_points',
	TIFF_TO_JPEG_SCROLLED_POINTS: 'tiffToJpeg_scrolled_points',
	TIFF_TO_PNG_SCROLLED_POINTS: 'tiffToPng_scrolled_points',
	BMP_TO_JPEG_CONVERTER_SCROLLED_POINTS: 'bmpToJpeg_scrolled_points',
	BMP_TO_PNG_CONVERTER_SCROLLED_POINTS: 'bmpToPng_scrolled_points',
	BMP_TO_JPG_CONVERTER_SCROLLED_POINTS: 'bmpToJpg_scrolled_points',
	JPG_TO_BMP_CONVERTER_SCROLLED_POINTS: 'jpgToBmp_scrolled_points',
	JPG_TO_TIFF_CONVERTER_SCROLLED_POINTS: 'jpgToTiff_scrolled_points',
	JPEG_TO_TIFF_CONVERTER_SCROLLED_POINTS: 'jpegToTiff_scrolled_points',
	JPEG_TO_BMP_CONVERTER_SCROLLED_POINTS: 'jpegToBmp_scrolled_points',
	IMAGE_TO_JPEG_SCROLLED_POINTS: 'imageToJpeg_scrolled_points',
	IMAGE_TO_HEIC_SCROLLED_POINTS: 'imageToHeic_scrolled_points',
	IMAGE_TO_JPG_SCROLLED_POINTS: 'imageToJpg_scrolled_points',
	IMAGE_TO_BMP_CONVERTER_SCROLLED_POINTS: 'imageToBmp_scrolled_points',
	IMAGE_TO_TIFF_CONVERTER_SCROLLED_POINTS: 'imageToTiff_scrolled_points',
	PNG_TO_JPEG_SCROLLED_POINTS: 'pngToJpeg_scrolled_points',
	PNG_TO_BMP_CONVERTER_SCROLLED_POINTS: 'pngToBmp_scrolled_points',
	PNG_TO_JPG_SCROLLED_POINTS: 'pngToJpg_scrolled_points',
	JPEG_TO_JPG_SCROLLED_POINTS: 'jpegToJpg_scrolled_points',
	JPG_TO_JPEG_SCROLLED_POINTS: 'jpgToJpeg_scrolled_points',
	PNG_TO_WEBP_SCROLLED_POINTS: 'pngToWebp_scrolled_points',
	JPG_TO_WEBP_SCROLLED_POINTS: 'jpgToWebp_scrolled_points',
	JPEG_TO_WEBP_SCROLLED_POINTS: 'jpegToWebp_scrolled_points',
	JPEG_TO_PNG_SCROLLED_POINTS: 'jpegToPng_scrolled_points',
	JPG_TO_PNG_SCROLLED_POINTS: 'jpgToPng_scrolled_points',
	IMAGE_CONVERTER_SCROLLED_POINTS: 'imageConverter_scrolled_points',
	VIDEO_CONVERTER_SCROLLED_POINTS: 'videoConverter_scrolled_points',
	VIDEO_COMPRESSOR_SCROLLED_POINTS: 'videoCompressor_scrolled_points',
	VIDEO_BACKGROUND_REMOVER_SCROLLED_POINTS:
		'videoBackgroundRemover_scrolled_points',
	VIDEO_ENHANCER_SCROLLED_POINTS: 'videoEnhancer_scrolled_points',
	AI_VOICE_GENERATOR_SCROLLED_POINTS: 'aiVoiceGenerator_scrolled_points',
	TEXT_TO_SPEECH_SCROLLED_POINTS: 'textToSpeech_scrolled_points',
	AI_MUSIC_GENERATOR_SCROLLED_POINTS: 'aiMusicGenerator_scrolled_points',
	AI_SONG_GENERATOR_SCROLLED_POINTS: 'aiSongGenerator_scrolled_points',
	AI_TRANSCRIPTION_SCROLLED_POINTS: 'aiTranscription_scrolled_points',
	AUDIO_TO_TEXT_SCROLLED_POINTS: 'audioToText_scrolled_points',
	VIDEO_TO_TEXT_SCROLLED_POINTS: 'videoToText_scrolled_points',
	SPEECH_TO_TEXT_SCROLLED_POINTS: 'speechToText_scrolled_points',
	AI_SUMMARIZER_SCROLLED_POINTS: 'aiSummarizer_scrolled_points',
	VIDEO_SIZE_REDUCER_SCROLLED_POINTS: 'videoSizeReducer_scrolled_points',
	MP4_TO_MP3_CONVERTER_SCROLLED_POINTS: 'mp4ToMp3Converter_scrolled_points',
	MP3_CONVERTER_SCROLLED_POINTS: 'mp3Converter_scrolled_points',
	GIF_MAKER_SCROLLED_POINTS: 'gifMaker_scrolled_points',
	VIDEO_TO_MP3_CONVERTER_SCROLLED_POINTS: 'videoToMp3Converter_scrolled_points',
	MOV_TO_MP4_CONVERTER_SCROLLED_POINTS: 'movToMp4Converter_scrolled_points',
	VIDEO_TO_GIF_CONVERTER_SCROLLED_POINTS: 'videoToGifConverter_scrolled_points',
	MKV_TO_MP4_CONVERTER_SCROLLED_POINTS: 'mkvToMp4Converter_scrolled_points',
	MP4_TO_GIF_CONVERTER_SCROLLED_POINTS: 'mp4ToGifConverter_scrolled_points',
	VIDEO_TO_AUDIO_CONVERTER_SCROLLED_POINTS:
		'videoToAudioConverter_scrolled_points',
	AVI_TO_MP4_CONVERTER_SCROLLED_POINTS: 'aviToMp4Converter_scrolled_points',
	WEBM_TO_MP4_CONVERTER_SCROLLED_POINTS: 'webmToMp4Converter_scrolled_points',
	GIF_TO_MP4_CONVERTER_SCROLLED_POINTS: 'gifToMp4Converter_scrolled_points',
	MPEG_TO_MP3_CONVERTER_SCROLLED_POINTS: 'mpegToMp3Converter_scrolled_points',
	GIF_TO_VIDEO_CONVERTER_SCROLLED_POINTS: 'gifToVideoConverter_scrolled_points',
	MOV_TO_MP3_CONVERTER_SCROLLED_POINTS: 'movToMp3Converter_scrolled_points',
	MP4_TO_WAV_CONVERTER_SCROLLED_POINTS: 'mp4ToWavConverter_scrolled_points',
	MOV_TO_GIF_CONVERTER_SCROLLED_POINTS: 'movToGifConverter_scrolled_points',
	IMAGE_COMPRESSOR_SCROLLED_POINTS: 'imageCompressor_scrolled_points',
	LOWER_IMAGE_SIZE_SCROLLED_POINTS: 'lowerImageSize_scrolled_points',
	REDUCE_IMAGE_SIZE_SCROLLED_POINTS: 'reduceImageSize_scrolled_points',
	DECREASE_PICTURE_SIZE_SCROLLED_POINTS: 'decreasePictureSize_scrolled_points',
	MINIMIZE_PICTURE_SIZE_SCROLLED_POINTS: 'minimizePictureSize_scrolled_points',
	CONDENSE_IMAGE_SCROLLED_POINTS: 'condenseImage_scrolled_points',
	COMPRESS_JPG_SCROLLED_POINTS: 'compressJpg_scrolled_points',
	COMPRESS_JPEG_SCROLLED_POINTS: 'compressJpeg_scrolled_points',
	RESIZE_PHOTO_KB_SCROLLED_POINTS: 'resizePhotoKb_scrolled_points',
	SHRINK_IMAGE_ONLINE_SCROLLED_POINTS: 'shrinkImageOnline_scrolled_points',
	COMPRESS_PNG_SCROLLED_POINTS: 'compressPng_scrolled_points',
	COMPACT_IMAGES_SCROLLED_POINTS: 'compactImages_scrolled_points',
	IMAGE_TO_TEXT_SCROLLED_POINTS: 'imageToText_scrolled_points',
	AI_BABY_GENERATOR_SCROLLED_POINTS: 'aiBabyGenerator_scrolled_points',
	BABY_FACE_GENERATOR_SCROLLED_POINTS: 'babyFaceGenerator_scrolled_points',
	BLUR_IMAGE_SCROLLED_POINTS: 'blurImage_scrolled_points',
	BLUR_EFFECT_SCROLLED_POINTS: 'blurEffect_scrolled_points',
	BLUR_FACE_IN_PHOTO_SCROLLED_POINTS: 'blurFaceInPhoto_scrolled_points',
	BLUR_TEXT_IN_IMAGE_SCROLLED_POINTS: 'blurTextInImage_scrolled_points',
	PIXELATE_IMAGE_SCROLLED_POINTS: 'pixelateImage_scrolled_points',
	AI_AGE_PROGRESSION_SCROLLED_POINTS: 'aiAgeProgression_scrolled_points',
	AI_AGE_PROGRESSION_V2_SCROLLED_POINTS: 'aiAgeProgressionV2_scrolled_points',
	AI_AGE_FILTER_SCROLLED_POINTS: 'aiAgeFilter_scrolled_points',
	WHAT_WILL_I_LOOK_LIKE_WHEN_IM_OLDER_SCROLLED_POINTS:
		'whatWillILookLikeWhenImOlder_scrolled_points',
	IMAGE_SPLITTER_SCROLLED_POINTS: 'imageSplitter_scrolled_points',
	GRID_MAKER_SCROLLED_POINTS: 'gridMaker_scrolled_points',
	AI_PROFESSIONAL_HEADSHOT_GENERATOR_SCROLLED_POINTS:
		'aiProfessionalHeadshotGenerator_scrolled_points',
	AI_SPICY_HEADSHOT_GENERATOR_SCROLLED_POINTS:
		'aiSpicyHeadshotGenerator_scrolled_points',
	AI_PREGNANCY_HEADSHOT_GENERATOR_SCROLLED_POINTS:
		'aiPregnancyHeadshotGenerator_scrolled_points',
	FACE_SHAPE_DETECTOR_SCROLLED_POINTS: 'faceShapeDetector_scrolled_points',
	QR_CODE_GENERATOR_SCROLLED_POINTS: 'qrCodeGenerator_scrolled_points',
	BARCODE_GENERATOR_SCROLLED_POINTS: 'barcodeGenerator_scrolled_points',
	IDEOGRAM_AI_IMAGE_GENERATOR_SCROLLED_POINTS:
		'ideogramAiImageGenerator_scrolled_points',
	QWEN_IMAGE_AI_GENERATOR_SCROLLED_POINTS:
		'qwenImageAiGenerator_scrolled_points',
	VEO_AI_VIDEO_GENERATOR_SCROLLED_POINTS: 'veoAiVideoGenerator_scrolled_points',
	GEMINI_OMNI_AI_VIDEO_GENERATOR_SCROLLED_POINTS:
		'geminiOmniAiVideoGenerator_scrolled_points',
	WAN_3_0_AI_VIDEO_GENERATOR_SCROLLED_POINTS:
		'wan30AiVideoGenerator_scrolled_points',
	FLUX_3_VIDEO_AI_GENERATOR_SCROLLED_POINTS:
		'flux3VideoAiGenerator_scrolled_points',
	HAPPY_HORSE_AI_VIDEO_GENERATOR_SCROLLED_POINTS:
		'happyHorseAiVideoGenerator_scrolled_points',
	HAILUO_AI_VIDEO_GENERATOR_SCROLLED_POINTS:
		'hailuoAiVideoGenerator_scrolled_points',
	SEEDANCE_AI_VIDEO_GENERATOR_SCROLLED_POINTS:
		'seedanceAiVideoGenerator_scrolled_points',
	SEEDANCE_2_5_AI_VIDEO_GENERATOR_SCROLLED_POINTS:
		'seedance25AiVideoGenerator_scrolled_points',
	KLING_AI_VIDEO_GENERATOR_SCROLLED_POINTS:
		'klingAiVideoGenerator_scrolled_points',
	GROK_AI_VIDEO_GENERATOR_SCROLLED_POINTS:
		'grokAiVideoGenerator_scrolled_points',
	PIXVERSE_AI_VIDEO_GENERATOR_SCROLLED_POINTS:
		'pixverseAiVideoGenerator_scrolled_points',
	NANO_BANANA_AI_IMAGE_GENERATOR_SCROLLED_POINTS:
		'nanoBananaAiImageGenerator_scrolled_points',
	GROK_IMAGINE_AI_IMAGE_GENERATOR_SCROLLED_POINTS:
		'grokImagineAiImageGenerator_scrolled_points',
	RECRAFT_AI_IMAGE_GENERATOR_SCROLLED_POINTS:
		'recraftAiImageGenerator_scrolled_points',
	FLUX_2_AI_IMAGE_GENERATOR_SCROLLED_POINTS:
		'flux2AiImageGenerator_scrolled_points',
	GPT_IMAGE_AI_GENERATOR_SCROLLED_POINTS: 'gptImageAiGenerator_scrolled_points',
	MAI_IMAGE_AI_GENERATOR_SCROLLED_POINTS: 'maiImageAiGenerator_scrolled_points',
	META_MUSE_IMAGE_AI_GENERATOR_SCROLLED_POINTS:
		'metaMuseImageAiGenerator_scrolled_points',
	SEEDREAM_AI_IMAGE_GENERATOR_SCROLLED_POINTS:
		'seedreamAiImageGenerator_scrolled_points',
	IMAGE_TO_IMAGE_AI_SCROLLED_POINTS: 'imageToImageAi_scrolled_points',
	IMG_GEN_LANDING_DATA: 'img_gen_landing_data',
	VIDEO_GEN_LANDING_DATA: 'video_gen_landing_data',
} as const;
